module.exports = __webpack_public_path__ + "img/3-1.6d4d0567.png";